import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Contract} from '../../../shared/interface/contract';
import {Ofwca} from '../../../shared/interface/ofwca';
import {Partner} from '../../../shared/interface/partner';
import {Krk} from '../../../shared/interface/krk';
import {Registration} from '../../../shared/interface/registration';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {PartnerFacility} from "../../../shared/interface/partner-facility";
import {
  PartnerFacilityVerificationSalesProcess
} from "../../../shared/interface/partner-facility-verification-sales-process";
import {PersonalDataChange} from "../../../shared/interface/personalDataChange";
import {Device} from "../../../shared/interface/device";
import {CompetitionImport} from "../../../shared/interface/competition-import";
import {CompetitionImportRow} from "../../../shared/interface/competition-import-row";

export interface DocumentAddDialogData {
  contractObject?: Contract;
  ofwcaObject?: Ofwca;
  partnerObject?: Partner;
  krkObject?: Krk;
  registrationObject?: Registration;
  insuranceCompanyObject?: InsuranceCompany;
  facilitiesVerificationObject?: PartnerFacilityVerificationSalesProcess;
  personalDataChangeObject?: PersonalDataChange;
  competitionImportRowObject?: CompetitionImportRow;
  deviceObject?: Device;
  types: string[];
}

@Component({
  selector: 'app-document-add-dialog',
  templateUrl: './document-add-dialog.component.html',
  styleUrls: ['./document-add-dialog.component.scss']
})
export class DocumentAddDialogComponent implements OnInit {
  contractObject?: Contract = null;
  ofwcaObject?: Ofwca = null;
  partnerObject?: Partner = null;
  facilitiesVerificationObject?: PartnerFacilityVerificationSalesProcess = null;
  krkObject?: Krk = null;
  registrationObject?: Registration = null;
  insuranceCompanyObject?: InsuranceCompany = null;
  personalDataChangeObject?: PersonalDataChange = null;
  competitionImportRowObject?: CompetitionImportRow = null;
  deviceObject?: Device = null;
  types: string[];
  option?: string;
  register?: string;
  constructor(
    public dialogRef: MatDialogRef<DocumentAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentAddDialogData
  ) {
    this.contractObject = data.contractObject;
    this.ofwcaObject = data.ofwcaObject;
    this.partnerObject = data.partnerObject;
    this.krkObject = data.krkObject;
    this.registrationObject = data.registrationObject;
    this.insuranceCompanyObject = data.insuranceCompanyObject;
    this.facilitiesVerificationObject = data.facilitiesVerificationObject;
    this.personalDataChangeObject = data.personalDataChangeObject;
    this.competitionImportRowObject = data.competitionImportRowObject;
    this.deviceObject = data.deviceObject;
    this.types = data.types;
    this.register = "register";
    this.option = "KRK";
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
